// extracted by mini-css-extract-plugin
module.exports = {"content":"beyond-green-module--content--1hOpW","image":"beyond-green-module--image--7rJc9"};